//@flow
import React from 'react'
import './styles.css'

export default () => {

  return(
    <fb className="openUserCellMain">
      offene
    </fb>
  )
}



// WEBPACK FOOTER //
// ./src/containers/app/roster/weekPlan/shiftBoard/userRow/openUserCell/index.js